import { createFileRoute, Outlet, useLocation } from '@tanstack/react-router';
import { AppLayout } from '@/layouts/AppLayout';
import { requireAdminAccess } from '@/utils/authGuard';

export const Route = createFileRoute('/admin')({
  beforeLoad: async ({ location }) => {
    if (location.pathname === '/admin/login') {
      return;
    }
    await requireAdminAccess({ location });
  },
  component: function AdminRouteComponent() {
    const location = useLocation();
    if (location.pathname === '/admin/login') {
      return <Outlet />;
    }
    return (
      <AppLayout>
        <Outlet />
      </AppLayout>
    );
  },
});
